import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="layout-right, margin, padding" maskId="round-filled-radius-1-stroke-1.5-IconLayoutRight"><path d="M15.25 3C16.2165 3 17 3.7835 17 4.75V19.25C17 20.2165 16.2165 21 15.25 21H4.75C3.7835 21 3 20.2165 3 19.25V4.75C3 3.7835 3.7835 3 4.75 3H15.25Z" fill="currentColor"/><path d="M20.25 3C20.6642 3 21 3.33579 21 3.75V20.25C21 20.6642 20.6642 21 20.25 21C19.8358 21 19.5 20.6642 19.5 20.25V3.75C19.5 3.33579 19.8358 3 20.25 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutRight;
